import styled from "styled-components"

const ArianeSection = styled.nav`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  color: ${(props) => props.theme.a_color_gradients.a_medium};
`

export { ArianeSection }
